import { API } from "./api";

export const getVehiclesByOwner = (ownerId) =>
  API.get(`/vehicles/owner/${ownerId}`);
export const addVehicle = (vehicle) => API.post(`/vehicles`, vehicle);

export const deleteVehicle = (vehicleId) =>
  API.delete(`/vehicles/${vehicleId}`);

export const updateVehicle = (id, vehicles) =>
  API.put(`vehicles/${id}`, vehicles);

export const getOwners = () => API.get(`/owners`);
export const getAllVehicles = () => API.get(`/vehicles`);
export const getVehiclesWithType = (location, startDate, numberOfWeeks) =>
  API.post(`/vehicles/type`, { location, startDate, numberOfWeeks });
export const getAllVehicleTypes = () => API.get(`/vehicleType`);
export const getActiveMobileLocations = () =>
  API.get(`/mobileLocation?isActive=true`);
export const getAllVehiclesWithPricing = (startDate, numberOfWeeks) =>
  API.post(`/vehicles/date-range`, { startDate, numberOfWeeks });

export const getAllVehiclePricings = () => API.get(`/pricing`);

export const getActiveDefaultPricing = () => API.get(`/settings/active`);
